<div class="main-tab-title-box">
  <div><mat-card-title class="main-title" [innerHTML]="getTitleText()"></mat-card-title></div>
  <div>
    <analysis-options></analysis-options>
  </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysis will begin after you finish typing</div>
</div>
<div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>
<mat-card-content>
  <div id="button-switch-box">
    <div class="button-container left" [ngClass]="{'selected': isSelected('rank')}" (click)="selectMenuItem('rank')">
      <div style="margin-top: 8px;">
        <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;"
          src="./assets/images/extra_tab_icons/rank-icon.svg">
        <span class="main-box-title-14" style="padding-top: 2px;">Rank</span>
      </div>
    </div>
    <ng-container *ngIf="checked">
      <div class="separator"></div>
      <div class="button-container" [ngClass]="{'selected': isSelected('summary')}" (click)="selectMenuItem('summary')">
        <div style="margin-top: 9px;">
          <span class="main-box-title-14">Summary</span>
        </div>
      </div>
      <div class="separator"></div>
        <div class="button-container" [ngClass]="{'selected': isSelected('edits')}" (click)="selectMenuItem('edits')">
          <div style="margin-top: 8px;">
            <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;" src="./assets/images/extra_tab_icons/tokens-icon.svg">
              <span class="main-box-title-14" style="padding-top: 2px;">Estimates</span>
          </div>
        </div>
    </ng-container>
    <div class="separator"></div>
    <div class="button-container right" [ngClass]="{'selected': isSelected('charts')}"
      (click)="selectMenuItem('charts')">
      <div style="margin-top: 8px;">
        <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;"
          src="./assets/images/extra_tab_icons/charts-icon.svg">
        <span class="main-box-title-14" style="padding-top: 2px;">Charts</span>
      </div>
    </div>
  </div>
  <!------------------------------------>
  <!------------------------------------>
  <!---------------RANK----------------->
  <!------------------------------------>
  <!------------------------------------>
  <!------------------------------------>
  <ng-container *ngIf="selectedMenuItem === 'rank'">

    <span class="main-box-title-14">
    <div *ngIf="englishType === 'british'" >
      This section uses the British National Corpus (BNC) list to give exact frequencies, instead of relying on word families. Please click <a href="https://textinspector.com/help/british-national-corpus-bnc/" class="hiperlinks" target="_blank" rel="noopener noreferrer">here</a> for more information.
    </div>
    <div *ngIf="englishType === 'american'">
      This section uses the Corpus of Contemporary American English (COCA) lists to give exact frequencies, instead of relying on word families. Please click <a href="https://textinspector.com/help/corpus-of-contemporary-american-english-coca/" class="hiperlinks" target="_blank" rel="noopener noreferrer">here</a> for more information.
    </div>
      <br>
      The tools use the Text Inspector TAGGER tool to gain better accuracy. If a grammatical tag below is wrong, go back
      to the TAGGER tool, correct it, and Update it. Then come back here and click on Update Results for greater
      accuracy.</span>

    <div id="buttons-box">
      <button class="button-seeAll" (click)="toggleSeeAll()"  [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
        <img class="eye-icon" style="margin-right: 2px;" [src]="seeAllIconSrc">
        <span class="main-box-title-12">See All</span>
      </button>
      <span style="padding-left: 15px;">
        <button class="icon-button">
          <span class="button-block"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" class="export-con"></div><span>Lexis:
            {{ getButtonText() }} Export</span></span>
        </button>
      </span>

    </div>
    <!----------------------->
    <!----------------------->
    <!-----Advanced Mode----->
    <!----------------------->
    <!----------------------->
    <div class="content-show-all">
        <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()" [disabled]="isButtonDisabled()">
          {{ showAll ? 'Expand all' : 'Contract all' }}
        </button>
      </div>

    <div class="div_scroll_box">
      <ng-container *ngIf="checked">
        <ng-container *ngFor="let item of rank_data; let i = index">
          <div class="vertical-box" *ngIf="item.cantidad != 0">
            <div class="horizontal-box" style="border: none; margin-bottom: 0px; cursor: pointer;"
              [ngClass]="{'expanded': isExpanded[item.label]}" (click)="toggleExpand(item.label)">
              <div class="main-box-title-14" >
                <img class="eye-icon" *ngIf="!ishighlighted[item.label]" (click)="toggleEyeIcon(item.label,i ); $event.stopPropagation()"
                  src="../../assets/images/eye-icon.svg">
                <img class="eye-icon" *ngIf="ishighlighted[item.label]" (click)="toggleEyeIcon(item.label,i ); $event.stopPropagation()"
                  src="../../assets/images/yellow_icons/eye-on-icon.svg">
                <span id="box-score" [ngStyle]="{'background-color': colors[item.color]}">{{item.label}}</span>
                {{item.cantidad}} words ({{item.text | percent: '.2'}} of text) (Cumul: {{item.cumul | percent: '.2'}})
              </div>
              <mat-icon class="expand-icon">expand_more</mat-icon>
            </div>
            <div
            class="words-content"
              *ngIf="isExpanded[item.label]">
              <ng-container *ngFor="let palabra of getObjectKeys(item['words'])">
                <div class="item-listado-palabras">
                  {{palabra}}&nbsp; ({{item['words'][palabra]['value']}})
                  &nbsp; <b>{{item['words'][palabra]['tagger']}}</b>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>


    <!----------------------->
    <!----------------------->
    <!------Simple Mode------>
    <!----------------------->
    <!----------------------->
    <div class="div_scroll_box">
      <ng-container *ngIf="!checked">
        <ng-container *ngFor="let item of rank_data; let i = index">
          <div class="vertical-box" *ngIf="item.cantidad != 0">
            <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
              [ngClass]="{'expanded': isExpanded[item.label]}" (click)="toggleExpand(item.label)">
              <div>
                <img class="eye-icon" *ngIf="!ishighlighted[item.label]" (click)="toggleEyeIcon(item.label,i ); $event.stopPropagation()"
                  src="../../assets/images/eye-icon.svg">
                <img class="eye-icon" *ngIf="ishighlighted[item.label]" (click)="toggleEyeIcon(item.label,i ); $event.stopPropagation()"
                  src="../../assets/images/yellow_icons/eye-on-icon.svg">
              </div>
              <div class="main-box-title-14"><span id="box-score" [ngStyle]="{'background-color': colors[item.color]}">{{item.label}}</span>
              {{item.cantidad}} words ({{item.text | percent: '.2'}} of text)</div>
              <mat-icon class="expand-icon" >expand_more</mat-icon>
            </div>
            <div
            class="words-content"
              *ngIf="isExpanded[item.label]">
              <ng-container *ngFor="let palabra of getObjectKeys(item['words'])">
                <div class="item-listado-palabras">
                  {{palabra}}&nbsp; ({{item['words'][palabra]['value']}})
                  &nbsp; <b>{{item['words'][palabra]['tagger']}}</b>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>

      </ng-container>
    </div>

  </ng-container>


  <!------------------------------------>
  <!------------------------------------>
  <!-------------SUMMARY---------------->
  <!------------------------------------>
  <!------------------------------------>
  <!------------------------------------>
  <ng-container *ngIf="selectedMenuItem === 'summary'">

    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">Coverage</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.coverage.value ? summary.coverage.value
        : "--"}}% ({{summary.coverage.counted ? summary.coverage.counted : "--"}} counted /
        {{summary.coverage.no_counted ? summary.coverage.no_counted : "--"}} not counted)</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">Tokens (total items)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.tokens ? summary.tokens : "--"}}</div>
      <!--VER de donde sale el (250 counted) -->
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">Types (unique items)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.types ? summary.types : "--"}}</div>
      <!--VER de donde sale el (250 counted) -->
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">Elements (includes homonyms)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.elements ? summary.elements : "--"}}
      </div>
    </div>
    <div class="horizontal-box" *ngIf="englishType !='british'">
      <div class="main-box-title-14 temp-padd-left">Total coca Knowledge Rank (KR) (tokens)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.total_tokens ? summary.total_tokens :
        "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="englishType !='british'">
      <div class="main-box-title-14 temp-padd-left">Total coca Knowledge Rank (KR) (types)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.total_types ? summary.total_types :
        "--"}}</div>
    </div>

    <div class="horizontal-box" *ngIf="englishType !='american'">
      <div class="main-box-title-14 temp-padd-left">Total Lexical Frequency Count (tokens)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.total_tokens ? summary.total_tokens :
        "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="englishType !='american'">
      <div class="main-box-title-14 temp-padd-left">Total Lexical Frequency Count (types)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.total_types ? summary.total_types :
        "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">Mean LFC per token</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.mean_token ? summary.mean_token : "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">Mean LFC per type</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.mean_type ? summary.mean_type : "--"}}
      </div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">Mean LFC per 100 tokens</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.mean_100_tokens ?
        summary.mean_100_tokens : "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">Mean LFC per 100 types</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.mean_100_types ? summary.mean_100_types
        : "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 temp-padd-left">50th Percentile (types)
        <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">{{getTextToolTip()}}</span>
        </div>
      </div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.fifty_types ? summary.fifty_types :
        "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.sixty_types!=null">
      <div class="main-box-title-14 temp-padd-left">60th Percentile (types)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.sixty_types}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.seventy_types!=null">
      <div class="main-box-title-14 temp-padd-left">70th Percentile (types)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.seventy_types}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.eighty_types!=null">
      <div class="main-box-title-14 temp-padd-left">80th Percentile (types)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.eighty_types}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.fifty_tokens!=null">
      <div class="main-box-title-14 temp-padd-left">50th Percentile (tokens)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.fifty_tokens}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.sixty_tokens!=null">
      <div class="main-box-title-14 temp-padd-left">60th Percentile (tokens)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.sixty_tokens}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.seventy_tokens!=null">
      <div class="main-box-title-14 temp-padd-left">70th Percentile (tokens)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.seventy_tokens}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.eighty_tokens!=null">
      <div class="main-box-title-14 temp-padd-left">80th Percentile (tokens)</div>
      <div class="main-box-value-16-bold temp-padd-right ">{{summary.eighty_tokens}}</div>
    </div>
  </ng-container>
  <!------------------------------------>
  <!------------------------------------>
  <!---------------EDITS---------------->
  <!------------------------------------>
  <!------------------------------------>
  <!------------------------------------>
  <ng-container *ngIf="selectedMenuItem === 'edits'">
      
        <span class="main-box-title-16">{{total_tokens_estimated}} Words Estimated</span>
        <span class="main-box-title-14"><br>These words in your text could have an alternative grammar associated with them. 
            Click the swap icon to edit all instances of a word, or hover over the word within the main text to edit individual instances.</span>
            <div id="table_scroll">
              <div class="coca-estimates-header">
                <div class="coca-estimates-title coca-estimates-word">Word</div>
                <div class="coca-estimates-title coca-estimates-tag">Tag</div>
                <div class="coca-estimates-title coca-estimates-count">Count</div>
              </div>
              <div *ngFor="let project of projects.data" class="horizontal-box coca-estimates-row">
                <div class="main-box-title-14 coca-estimates-word">{{project.word}}</div>
                <div class="main-box-title-14 coca-estimates-tag">{{project.tag}}</div>
                <div class="main-box-value-16-bold coca-estimates-count">{{project.count}}</div>
              </div>
            </div>
    </ng-container>
  <!------------------------------------>
  <!------------------------------------>
  <!--------------CHARTS---------------->
  <!------------------------------------>
  <!------------------------------------>
  <!------------------------------------>
  <ng-container *ngIf="selectedMenuItem === 'charts'">

    <div class="chart-container">
      <div
        style="width: auto;align-items: center; text-align: center; font-size: 14px; font-weight: bold; font-family: 'Inter';color: #2A3654; margin-bottom: 20px;">
        Types % 0-10k</div>
        <div class="scroll_chart">
        <div class="size_chart">
        <canvas style="width: 100%; height: 340px; margin-left: 10%;margin-right: 10%; padding-bottom: 10px;" baseChart
          [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
        </canvas>
      </div>
      </div>
    </div>

    <div class="chart-container">
      <div
        style="width: auto;align-items: center; text-align: center; font-size: 14px; font-weight: bold; font-family: 'Inter';color: #2A3654; margin-bottom: 20px;">
        Types % 0-100k</div>
        <div class="scroll_chart">
          <div class="size_chart">
      <canvas style="width: 100%; height: 340px; margin-left: 10%;margin-right: 10%; padding-bottom: 10px;" baseChart
        [data]="barChartData2" [options]="barChartOptions" [type]="barChartType2 ">
      </canvas>
    </div>
  </div>
    </div>

  </ng-container>
  <ng-container *ngIf="!checked">
    <div class="text-box-bottom-simple-mode">
      <div class="line-box-bottom-simple-mode">
        <div class="bottom-text-line-simple-mode"></div>
      </div>
      <span class="main-box-title-14">To see full statistics, switch to “Advanced Mode”.</span>
    </div>
  </ng-container>

</mat-card-content>
